import {Component, Input} from '@angular/core';

@Component({
	selector: 'groin-logo',
	standalone: true,
	templateUrl: './groin-logo.component.html',
	styleUrl: './groin-logo.component.scss',
	host: {
		'role': 'img',
		'[attr.aria-label]': 'ariaLabel',
		'[class.groin-logo--static]': '!animated',
	},
})
export class GroinLogoComponent {
	@Input() animated = true;
	@Input() ariaLabel = 'Groin';
}
